const translations = {
  'resources.seo.title': 'Recursos y materiales de enseñanza gratuitos de TEFL España',
  'resources.seo.description': `TEFL Iberia proporciona recursos didácticos y materiales gratuitos de TEFL. Eche un vistazo en línea y descargue nuestros recursos de forma gratuita.`,
  'resources.sec1.title': `Recursos `,
  'resources.sec1.description': `TEFL Iberia te proporciona recursos didácticos y materiales gratuitos para profesores de inglés como segunda lengua. Echa un vistazo y descarga nuestros recursos de forma gratuita.`,
  'resources.tab1.text': `Empleos de enseñanza de inglés`,
  'resources.tab2.text': `Recursos de enseñanza y aprendizaje de inglés`,
  'resources.tab3.text': `Barcelona`,
  'resources.tab4.text': `Sevilla`,
  'resources.tab1.r1.title': `Jooble`,
  'resources.tab1.r1.text': ` Motor de búsqueda de empleo: busca en todos los sitios web de clasificados principales para encontrar ofertas de trabajo actualizadas.`,
  'resources.tab1.r2.title': `Lingo Bongo`,
  'resources.tab1.r2.text': `Nombre genial, sitio web genial. Muy activo para ofertas de trabajo e intercambios lingüísticos.`,
  'resources.tab1.r3.title': `Trabajos de TEFL en España`,
  'resources.tab1.r3.text': `Sección de trabajos en TEFL.com.`,
  'resources.tab1.r4.title': `Info Jobs`,
  'resources.tab1.r4.text': `Ofertas de trabajo publicadas para trabajos de TEFL en Barcelona.`,
  'resources.tab1.r5.title': `TEFL Jobs World`,
  'resources.tab1.r5.text': `Trabajos, artículos y consejos para profesores de TEFL en todo el mundo`,

  'resources.tab2.r1.title': `British Council y sus recursos de aprendizaje`,
  'resources.tab2.r1.text': `Mucho material de calidad del British Council.`,
  'resources.tab2.r2.title': `Breaking News English`,
  'resources.tab2.r2.text': `Un sitio web fantástico, con muchos planes de lecciones listos para usar basados en noticias actuales.`,
  'resources.tab2.r3.title': `ITESLJ`,
  'resources.tab2.r3.text': `Otro favorito, especialmente útil para temas de discusión. Tiene una enorme lista de todos los temas que puedas imaginar y una gran lista de preguntas para iniciar la discusión entre estudiantes.`,
  'resources.tab2.r4.title': `Grammar.net`,
  'resources.tab2.r4.text': `Muchos consejos útiles e infografías divertidas para estudiantes.`,
  'resources.tab2.r5.title': `Guardian TEFL`,
  'resources.tab2.r5.text': `La sección de TEFL del periódico The Guardian con artículos, recursos y noticias.`,
  'resources.tab2.r6.title': `English Page`,
  'resources.tab2.r6.text': `Un sitio fantástico tanto para profesores de inglés como para estudiantes; tiene excelentes explicaciones de muchos puntos gramaticales.`,
  'resources.tab2.r7.title': `Planes de lecciones de inglés gratis de Tim`,
  'resources.tab2.r7.text': `Planes de lecciones comunicativas de alta calidad creadas con amor por Tim.`,

  'resources.tab3.r1.title': `Barcelona Metropolitan`,
  'resources.tab3.r1.text': `Revista en inglés popular con un buen sitio web que cubre los eventos mensuales en Barcelona.`,
  'resources.tab3.r2.title': `Barcelona LeCool`,
  'resources.tab3.r2.text': `Guía alternativa de Barcelona.`,
  'resources.tab3.r3.title': `Transporte público de Barcelona`,
  'resources.tab3.r3.text': `Información sobre autobuses, metro y tranvías en Barcelona.`,
  'resources.tab3.r4.title': `Renfe Cercanías`,
  'resources.tab3.r4.text': `Horario de trenes de cercanías locales.`,

  'resources.tab4.r1.title': `Not Just a Tourist – Flamenco`,
  'resources.tab4.r1.text': `Lee acerca de los 12 mejores lugares para ver flamenco en Sevilla.`,
  'resources.tab4.r2.title': `Not Just a Tourist – Museums`,
  'resources.tab4.r2.text': `Descubre los 8 mejores museos de Sevilla.`,
  'resources.tab4.r3.title': `Ibérico Club`,
  'resources.tab4.r3.text': `Descubre cuáles son los 10 mejores bares de tapas en Sevilla.`,
  'resources.tab4.r4.title': `Visita Seville`,
  'resources.tab4.r4.text': `Lee sobre los increíbles 28 parques y jardines de Sevilla.`,
  'resources.tab4.r5.title': `Seville City Guide`,
  'resources.tab4.r5.text': `Descubre los días festivos, eventos y festivales de Sevilla.`,
  'resources.tab4.r6.title': `Welcome to Seville`,
  'resources.tab4.r6.text': `Visita los famosos mercados callejeros y de pulgas en Sevilla.`,
};

export default translations;
